module.exports = __webpack_public_path__ + "img/face1.d0e08631.png";